import { FC } from 'react';
import Status from 'pages/UserPage/TableSection/Status/Status';
import SplitSchedulingBadge from 'components/SplitSchedulingBadge/SplitSchedulingBadge';
import { CLINIC_USER_STATUS } from 'utils/constants';

interface StatusColumnProps {
  field: any;
}
const { ACTIVE, INACTIVE } = CLINIC_USER_STATUS;

const StatusColumn: FC<StatusColumnProps> = ({ field }) => {
  if (!field.isSplitScheduling) {
    return <Status status={field.isActive ? ACTIVE : INACTIVE} />;
  }
  return (
    <div className="flex gap-x-0.5">
      <Status status={field.isActive ? ACTIVE : INACTIVE} />
      <SplitSchedulingBadge tooltipId="splitScheduling" />
    </div>
  );
};

export default StatusColumn;
